import types from 'actions/types'
import {combineReducers} from 'redux'

export const visible = (state = false, action) => {
  switch (action.type) {
        case types.SHOW_DELETE_PART_CATEGORY_DIALOG: return true
            case types.HIDE_DELETE_PART_CATEGORY_DIALOG: return false
            default:
              return state
              }
}

export const category = (state = null, action) => {
  switch (action.type) {
        case types.SHOW_DELETE_PART_CATEGORY_DIALOG: return action.category
            case types.HIDE_DELETE_PART_CATEGORY_DIALOG: return null
            default:
              return state
              }
}

export default combineReducers({
  visible,
  category,
})